module.exports = __webpack_public_path__ + "static/iconography-style-dont-f28736d26b13f2583e0d5d16d1f145b0.png";